// https://vuex.vuejs.org/en/modules.html
const requireModule = require.context('.', true, /\.js$/)

// TODO Automate this !
let modules = {
  app: {
    namespaced: true,
    mutations: requireModule('./app/mutations.js').default,
    state: requireModule('./app/state.js').default
  },
  user: {
    namespaced: true,
    mutations: requireModule('./user/mutations.js').default,
    state: requireModule('./user/state.js').default,
    getters: requireModule('./user/getters.js').default,
    actions: requireModule('./user/actions.js').default
  },
  worktools: {
    namespaced: true,
    modules: {
      temps: {
        namespaced: true,
        mutations: requireModule('./worktools/temps/mutations.js').default,
        state: requireModule('./worktools/temps/state.js').default,
        actions: requireModule('./worktools/temps/actions.js').default,
        getters: requireModule('./worktools/temps/getters.js').default
      },
      clients: {
        namespaced: true,
        mutations: requireModule('./worktools/clients/mutations.js').default,
        state: requireModule('./worktools/clients/state.js').default,
        actions: requireModule('./worktools/clients/actions.js').default,
        getters: requireModule('./worktools/clients/getters.js').default
      },
      tarifHoraire: {
        namespaced: true,
        mutations: requireModule('./worktools/tarifHoraire/mutations.js').default,
        state: requireModule('./worktools/tarifHoraire/state.js').default,
        actions: requireModule('./worktools/tarifHoraire/actions.js').default,
        getters: requireModule('./worktools/tarifHoraire/getters.js').default
      },
      dossiers: {
        namespaced: true,
        mutations: requireModule('./worktools/dossiers/mutations.js').default,
        state: requireModule('./worktools/dossiers/state.js').default,
        actions: requireModule('./worktools/dossiers/actions.js').default,
        getters: requireModule('./worktools/dossiers/getters.js').default
      }
    }
  }
}

export default modules
